export default function UserStorage(localStorageService, Log) {
    const storageKey = "user";

    /**
     * interface with localStorageService
     */
    const StorageFacade = {
        get: () => {
            return localStorageService.get(storageKey);
        },

        set: (storageObj) => {
            localStorageService.set(storageKey, storageObj);
        },

        removeAll: () => {
            localStorageService.remove(storageKey);
        },
    };

    // const storageModel = {
    //     lastLoggedUserID: null, // int
    //     userSwitchDetected: false,
    // };

    var fn = this;

    /**
     * construct
     */
    // fn.init = () => {
    //     let storage = StorageFacade.get();

    //     if (!storage) {
    //         StorageFacade.set(storageModel);

    //         return storageModel;
    //     }

    //     return storage;
    // };

    /*******************************************************
     * Getters / Setters
     */

    // fn.getLastLoggedUserId = () => {
    //     let storage = StorageFacade.get();

    //     return storage ? storage.lastLoggedUserID : null;
    // };

    // fn.setLastLoggedUserId = (userId) => {
    //     let storage = StorageFacade.get();

    //     storage.lastLoggedUserID = userId;

    //     StorageFacade.set(storage);
    // };

    // fn.deleteLastLoggedUserId = () => {
    //     let storage = StorageFacade.get();

    //     storage.lastLoggedUserID = null;

    //     StorageFacade.set(storage);
    // };

    // fn.setUserSwitchDetected = (bool) => {
    //     let storage = StorageFacade.get();
    //     // console.log("Set UserSwitchDetected");
    //     storage.userSwitchDetected = bool;

    //     StorageFacade.set(storage);
    // };

    // fn.getUserSwitchDetected = () => {
    //     let storage = StorageFacade.get();
    //     // console.log("get UserSwitchDetected");
    //     return storage.userSwitchDetected;
    // };

    // fn.create = (user) => {
    //     let storage = StorageFacade.get();

    //     storage.user = user;

    //     StorageFacade.set(storage);
    // };

    // fn.delete = () => {
    //     StorageFacade.removeAll();
    // };

    return fn;
}
